module.exports = __webpack_public_path__ + "img/icon-save-purple.c4e8c8f9.svg";